// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from './en.json';
import translationEs from './es.json';
import translationFra from './fra.json';
import translationAleman from './deutsch.json';
import translationItalia from './ita.json';
import translationPortugues from './por.json';
import translationHolandes from './neer.json';

const resources = {
  en: {
    translation: translationEn,
  },
  es: {
    translation: translationEs,
  },
  fra: {
    translation: translationFra,
  },
  deutsch: {
    translation: translationAleman,
  },
  ita: {
    translation: translationItalia,
  },
  por:{
    translation: translationPortugues,
  },
  ner:{
    translation: translationHolandes,
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'es', // Idioma por defecto
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false, // React ya se encarga de escapar
  },
});

export default i18n;
